import { defineComponent as _defineComponent } from 'vue'
import logo from '@/assets/logo-somar.png'

export default /*#__PURE__*/_defineComponent({
  __name: 'Logo',
  setup(__props) {

// @ts-ignore

return { __sfc: true,logo }
}

})